import React from 'react';
import useTranslation from '../hooks/useTranslation';

/**
 * Shared recording controls with timer and mic button
 * Used by CorporateDashboard, SchoolUniversityHome, TakeCareAgencyDashboard, etc.
 */
export default function RecordingControls({
  timer,
  running,
  segmentRecording,
  continuousRecording,
  micClicks,
  onMicClick,
  selectedEntity,
  maxClicks = 5,
  className = 'su-rec-btn',
  t
}) {
  const { t: defaultT } = useTranslation();
  const translate = t || defaultT;
  
  const formatTimer = (seconds) => {
    return new Date(seconds * 1000).toISOString().substr(11, 8);
  };

  return (
    <>
      <div style={{ display: "flex", gap: 8, marginBottom: 16, alignItems: "center" }}>
        <div style={{ 
          display: "flex", 
          alignItems: "center", 
          gap: 8,
          flex: 1,
          padding: "10px 12px",
          background: "var(--edu-bg-muted)",
          borderRadius: 8,
          border: "1px solid var(--edu-border)"
        }}>
          <span style={{ fontSize: 20 }}>⏱️</span>
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: 11, color: "var(--edu-text-light)", textTransform: "uppercase", letterSpacing: 0.5 }}>{translate("Session Duration")}</div>
            <div style={{ fontSize: 18, fontWeight: 700, color: "var(--edu-text-dark)", fontFamily: "monospace" }}>
              {formatTimer(timer)}
            </div>
          </div>
          {running ? (
            <div style={{ 
              width: 10, 
              height: 10, 
              borderRadius: "50%", 
              background: segmentRecording || continuousRecording ? "#EF4444" : "#10B981",
              animation: "pulse 1.5s infinite"
            }} />
          ) : null}
        </div>
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
        <button
          className={className}
          onClick={onMicClick}
          disabled={!selectedEntity || micClicks >= maxClicks || segmentRecording}
          style={{
            background: segmentRecording ? "linear-gradient(135deg, #ef4444 0%, #dc2626 100%)" : "linear-gradient(135deg, #3b82f6 0%, #60a5fa 100%)",
          }}
        >
          <span style={{ fontSize: 18 }}>🎤</span>
          <div style={{ flex: 1, textAlign: "left" }}>
            <div style={{ fontWeight: 600, fontSize: 13 }}>{translate("Segment Recording")}</div>
            <div style={{ fontSize: 11, opacity: 0.85 }}>{translate("5 × 8-second samples")}</div>
          </div>
          <div style={{ 
            background: "rgba(255,255,255,0.2)", 
            padding: "4px 10px", 
            borderRadius: 6, 
            fontWeight: 700,
            fontSize: 13
          }}>
            {segmentRecording ? translate("Recording...") : `${micClicks}/${maxClicks}`}
          </div>
        </button>
      </div>
    </>
  );
}
